import type { ReactNode } from 'react'
import { cn } from '../cn'
import { type BreadcrumbItem, Breadcrumbs } from './Breadcrumbs'
import { Eyebrow } from './Card'

export interface PageHeaderProps {
  /** The page's only h1 (UXR-016). */
  title: ReactNode
  /** Kicker above the title ("PORTFOLIO COVERAGE"). */
  eyebrow?: ReactNode
  description?: ReactNode
  actions?: ReactNode
  breadcrumbs?: BreadcrumbItem[]
  className?: string
}

export function PageHeader({
  title,
  eyebrow,
  description,
  actions,
  breadcrumbs,
  className,
}: PageHeaderProps) {
  return (
    <header className={cn('mb-8', className)}>
      {breadcrumbs && breadcrumbs.length > 0 ? (
        <Breadcrumbs items={breadcrumbs} className="mb-5" />
      ) : null}
      <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
        <div className="min-w-0 max-w-3xl">
          {eyebrow ? <Eyebrow>{eyebrow}</Eyebrow> : null}
          <h1 className="mt-2 font-display text-[28px] font-semibold leading-[1.2] tracking-[var(--tracking-heading)] text-ink sm:text-[34px]">
            {title}
          </h1>
          {description ? (
            <p className="mt-3 text-[15px] leading-relaxed text-sage sm:text-base">{description}</p>
          ) : null}
        </div>
        {actions ? (
          <div className="flex shrink-0 flex-wrap items-center gap-2.5">{actions}</div>
        ) : null}
      </div>
    </header>
  )
}
